import PresetWindowLevelState from "./presetWindowLevelState";

let selectedMeasure = "";

function setSelectedMeasure(measureName) {
  if (typeof measureName !== "string") {
    return;
  }

  selectedMeasure = measureName;
}
function getSelectedMeasure() {
  return selectedMeasure;
}

const SelectedMeasure = {
  setSelectedMeasure,
  getSelectedMeasure
};

const store = {
  SelectedMeasure,
  PresetWindowLevelState
};

export default store;
